import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { CameraService } from 'src/app/services/camera/camera.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import {
  AlertService,
  MessageSeverity,
} from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-modal-camera-counter',
  templateUrl: './modal-camera-counter.component.html',
  styleUrls: ['./modal-camera-counter.component.css'],
})
export class ModalCameraCounterComponent implements OnInit {
  pinForm: FormGroup;
  edit = false;
  image: File;

  constructor(
    public dialogRef: MatDialogRef<ModalCameraCounterComponent>,
    private alertService: AlertService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private cameraService: CameraService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    console.log(this.data);
    this.createForm();
    if (this.data.action == AppConstants.OperationType.UPDATE) {
      this.pinForm.controls['name'].setValue(this.data.obj.name);
    }
  }

  createForm() {
    this.pinForm = this.formBuilder.group({
      name: ['', [Validators.required]],
    });
  }

  get f() {
    return this.pinForm.controls;
  }

  closeModal() {
    this.dialogRef.close({ result: false });
  }

  save() {
    if (this.pinForm.valid) {
      var data = new FormData();

      data.append(
        'id',
        this.data.action == AppConstants.OperationType.UPDATE
          ? this.data.obj.id
          : 0
      );

      data.append('name', this.pinForm.value['name']);
      data.append('idHeadquarter', this.data.idHeadquarter);
      data.append('idEnterprise', this.data.idEnterprise);
      data.append('idCamera', this.data.idCamera);
      data.append('idUser', localStorage.getItem(AppConstants.Session.USERID));

      if (this.data.action == AppConstants.OperationType.ADD) {
        this.spinner.show();
        this.cameraService.createRegionCameraCounter(data).subscribe((_) => {
          if (!_.message) {
            this.alertService.showMessage(
              AppConstants.TitleModal.CREATE_REGION_CAMERA_COUNTER,
              AppConstants.MessageModal.CREATE,
              MessageSeverity.success
            );
            this.data.result = true;
            this.dialogRef.close({ result: true });
          } else {
            this.alertService.showMessage(_.message, '', MessageSeverity.error);
          }
          this.spinner.hide();
        });
      }
      
      if (this.data.action == AppConstants.OperationType.UPDATE) {
        this.spinner.show();
        this.cameraService.updateRegionCameraCounter(data).subscribe((_) => {
          if (!_.message) {
            this.alertService.showMessage(
              AppConstants.TitleModal.UPDATE_REGION_CAMERA_COUNTER,
              AppConstants.MessageModal.UPDATE,
              MessageSeverity.success
            );
            this.data.result = true;
            this.dialogRef.close({ result: true });
          } else {
            this.alertService.showMessage(_.message, '', MessageSeverity.error);
          }
          this.spinner.hide();
        });
      }
    } else {
      this.pinForm.markAllAsTouched();
    }
  }
}
